const VALID_EMAIL_REGEX = /.@./;

export function validEmail(email: string): boolean {
  return VALID_EMAIL_REGEX.test(email);
}
